<template>
  <div class="training-step-classification">
    <!-- 目标校验文件 -->
    <TargetVerificationFile
      v-if="uploadTipsType == 3"
      :modelType="modelType"
      :teacherOrStudentState="teacherOrStudentState"
      :PicturesData="PicturesData"
      @getTargetFile="getTargetFile"
      :modelLimitButtonShow="modelLimitButtonShow"
      :releaseStatus="releaseStatus"
      @uploadPictures="uploadPictures"
      @onTargetFile="onTargetFile"
    ></TargetVerificationFile>

    <!-- 分类文件界面 -->
    <div class="main" v-if="uploadTipsType == 1">
      <div class="dataset-get">
        <div class="select-tool">
          <span class="label">
            <i class="required">*</i>
            选择数据集：
          </span>
          <el-select v-model="activeDataset" placeholder="请选择" filterable>
            <el-option
              v-for="item in datasetOptions"
              :key="item.datasetId"
              :label="item.datasetName"
              :value="item.datasetId">
            </el-option>
          </el-select>
          <span class="state-span">数据集状态： 
            <span class="state-text">
              {{datasetStatus}}{{datasetStatus==='准备就绪' && targetFileList.length===0?`，请上传目标校验${modelTypeCompany(modelType)}`:''}}
            </span>
          </span>
        </div>
        <div class="go-to-dataset" v-show="activeDataset && activeLabel" @click="onTargetFile('3')">
          <i class="el-icon el-icon-right"></i>
          <span>目标校验{{modelTypeCompany(modelType)}}</span>
        </div>
      </div>

      <!-- 选定数据集后显示 -->
      <div class="bnts-tag" v-show="activeDataset">
        <button class="btn-primary">标签筛选</button>

        <button
          :class="['btn-add-tag', {'events-disable': releaseStatus || modelLimitButtonShow}]"
          title="添加标签"
          @click="activeAddTagPopup"
        ></button>

        <!-- 选定数据集和标签分类后显示 -->
        <!-- <el-button
          type="primary"
          class="quote-upload btn-primary"
          @click="quoteDataset"
          v-show="activeDataset && activeLabel"
        >引用数据集</el-button> -->
        <el-button
          type="primary"
          :class="['btn-upload', 'btn-primary', {'events-disable': releaseStatus || modelLimitButtonShow}]"
          @click="uploadPictures"
          v-show="activeDataset && activeLabel"
        >本地上传</el-button>
        <el-alert :title="`* 每个标签的${modelTypeCompany(modelType)}不少于20${modelType==1?'张':'个'}`" type="error"> </el-alert>
      </div>
      <!-- 有图片数据显示 -->
      <!-- 图片累计 -->
      <span class="dataset-pic-total" v-show="Pictures.total">
        {{ `累计${Pictures.total}${modelType==1?'张':'个'}${modelTypeCompany(modelType)}` }}
      </span>
      <div class="group-tag">
        <a
          href="javascript:void(0);"
          v-for="(item, idx) in Label.records"
          :class="['h-tag', activeLabel === item.labelId ? 'active' : '']"
          @click="activeCatetoryLabel(item.labelId, idx)"
          :key="idx"
        >
          <span>{{ item.labelName }}</span>
          <i
            :class="['btn-edit', 'el-icon-edit-outline', {'events-disable': releaseStatus || modelLimitButtonShow}]"
            @click.stop="activeRenameLabelPopup(item.labelName, item.labelId, idx)"
          ></i>
          <i 
            :class="['btn-del', 'el-icon-close', {'events-disable': releaseStatus || modelLimitButtonShow}]"
            @click.stop="activeLabelDeletePopup(item.labelId, item.datasetId, idx)"
          ></i>
        </a>
      </div>

      <div class="picture-box">
        <!-- 文件列表 -->
        <ul class="pictures">
          <li class="no-data" v-if="Pictures.records && Pictures.records.length === 0">
            <img :src="emptyImgUrl" alt="">
            <span>{{Pictures.records.length === 0 ? '当前无数据，开始上传吧~' : '当前无数据'}}</span>
          </li>
          <li class="picture-item" v-for="(item, idx) in Pictures.records" :key="idx">
            <i :class="[
              'preview-icon', modelType==1 || modelType==2 ? 
              'icon-see-img': (modelType==3 || modelType==4 ? 
              'el-icon-full-screen':'icon-caret-preview')]"
              @click="onFilePreview(item.fileUrl)"
              title="预览"
            ></i>
            <figure>
              <img class="img" v-if="modelType == 1 || modelType == 2" :src="photoBaseUrl + item.fileUrl" alt="" />
              <img class="img-top" v-if="modelType == 3 || modelType == 4" src="@/assets/images/txtImage@2x.png" alt="" />
              <img class="img-top" v-if="modelType == 5 || modelType == 6" src="@/assets/images/audioImage@2x.png" alt="" />
            </figure>
            <div class="btns" v-show="releaseStatus ? false : !modelLimitButtonShow">
              <button class="btn-delete" @click="activeDeletePopup(item.fileId, idx)">删除</button>
              <button class="btn-primary" @click="activeRenamePopup(item, idx)">重命名</button>
            </div>
            <div class="title ellipsis" :title="item.fileName">
              {{ item.fileName }}
            </div>
          </li>
        </ul>

        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page.sync="pagination.currentPage"
            :page-size="pagination.pageSize"
            :pager-count="pagination.pagerCount"
            layout="slot, prev, pager, next"
            :total="pagination.totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 删除 -->
      <gat-popup
        :class="[
          'popup-delete popup-delete-2',
          popupActive === 'delete' || popupActive === 'label_delete'
            ? 'on'
            : 'off',
        ]"
        :title="popupActive === 'delete'? `删除${modelTypeCompany(modelType)}`:'删除标签'"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteOperate"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span v-show="popupActive === 'label_delete'" class="title"
                >确定删除此分类及全部{{modelTypeCompany(modelType)}}吗？</span
              >
              <span v-show="popupActive === 'delete'" class="title"
                >确定删除此{{modelTypeCompany(modelType)}}吗？</span
              >
            </div>
          </div>
        </template>
      </gat-popup>
      <!-- 重命名 -->
      <gat-popup
        :class="['popup-rename', popupActive === 'rename' ? 'on' : 'off']"
        :title="'重命名'"
        @cancel="cancelPopup"
        @confirm="renameOperate"
      >
        <template v-slot:content>
          <el-input placeholder="请输入重命名" v-model.trim="popupData.rename.value" maxlength="20" show-word-limit />
        </template>
      </gat-popup>
      <!-- 添加新标签 -->
      <gat-popup
        :class="['popup-add-tag', popupActive === 'add_tag' ? 'on' : 'off']"
        :title="'添加分类'"
        @cancel="cancelPopup"
        @confirm="addLabel"
      >
        <template v-slot:content>
          <div v-if="Label.records&&Label.records.length >= 15">
            <p class="p-tip">
              单个数据集的分类标签数最多不超过15个哦~
            </p>
            <div class="button-row">
              <el-button type="primary" @click="cancelPopup">我知道了</el-button>
            </div>
          </div>
          <div v-else>
            <el-input placeholder="新的分类命名" v-model.trim="popupData.labelName" maxlength="20" show-word-limit />
            <p class="tip-list">
              <i class="required">*</i>单个数据集的分类标签数最多不超过15个。
            </p>
          </div>
        </template>
      </gat-popup>
      <!-- 上传图片提示 -->
      <model-training-upload-tips
        :modelType="modelType"
        :popupActive="popupActive"
        :uploadTipsType="uploadTipsType"
        @confirmUploadTip="confirmUploadTip"
        @cancelPopup="cancelPopup"
        @uploadNoTipChange="uploadNoTipChange"
      ></model-training-upload-tips>
      <!--文件预览-->
      <file-preview
        :modelType="modelType"
        :fileUrl="fileUrl"
        :dialogvisibleview="dialogvisibleview"
        @onClickDialog="dialogvisibleview = false"
      ></file-preview>
    </div>
  </div>
</template>

<script>
import COMMON from '@/axios/common/common.js';
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js'; // 项目标注接口

import GatPopup from '@/components/common/GatPopup';
import IconInfoHelp from '@/components/icons/typography/InfoHelp';

import ModelTrainingUploadTips from '@/components/pretrain/ModelTrainingUploadTips.vue';
import FilePreview from '@/components/pretrain/FilePreview.vue';
import TargetVerificationFile from './components/TargetVerificationFile.vue';

import { GetVerifyImgs } from '@/assets/js/mixin/mixinGetVerifyImgs.js'

export default {
  name: 'TrainingStepClassification',
  mixins: [GetVerifyImgs],
  components: {
    GatPopup,
    IconInfoHelp,
    ModelTrainingUploadTips,
    FilePreview,
    TargetVerificationFile,
  },
  props: {
    trainingId: {
      type: String,
      default: ''
    },
    modelType: {
      type: String,
      default: '1'
    },
    teacherOrStudentState: {
      type: Boolean,
      default: false
    },
    datasetOptions: {
      type: Array,
      default: []
    },
    datasetStatus: {
      type: String,
      default: '1'
    },
    modelLimitButtonShow: {
      type: Boolean,
      default: false
    },
    releaseStatus: {
      type: Boolean,
      default: false
    },
    targetFileList: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址
      fileUrl: '',
      uploadTipsType: '1', // 提示类型：1 数据集上传提示，2 模型校验上传提示，3 目标校验上传提示
      Label: {
        records: [],
        current: 1,
        pageSize: 30,
        total: 0,
      },
      PicturesData: [], // 目标文件 
      // 文件集
      Pictures: {
        records: [],
        size: 20,
        current: 1,
        total: 0,
      },
      activeDataset: '',
      activeLabel: null,
      // 翻页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        totalCount: 0,
        pagerCount: 5,
      },
      // 弹窗
      popupActive: '',
      popupData: {
        pictureId: '',
        pictureName: '',
        rename: {
          index: -1,
          value: '',
          imgName: '',
        },
        uploadNoTip: false,
        uploadNoTipTarget: false,
        labelName: '',
        delete: {
          index: -1,
        },
        labelDelete: {
          index: -1,
          labelId: '',
          datasetId: '',
        },
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
      formdata: new FormData(),
      fullscreenLoading: null, // 加载效果
      dialogvisibleview: false, // 预览文件弹窗
      drawerShow: false, // 引用数据集弹窗
      emptyImgUrl: require('../../../assets/images/datasetLobby/icon-empty-box.png'),
    }
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  watch: {
    // token() {
    //   this.getDatasetPageList();
    // },
    datasetOptions: {
      handler(val) {
        if (val && val.length) {
          this.activeDataset = val[0].datasetId
        } else {
          this.activeDataset = ''
        }

        if (this.activeDataset) {
          this.getLabelList().then(() => {
            this.getPictureList();
          })
        }
      },
      deep: true,
      immediate: true,
    },
    activeDataset() {
      // 重新初始化
      this.Pictures = {
        records: [],
        size: 20,
        current: 1,
        total: 0,
      }
      this.PicturesData = []

      this.activeLabel = null;

      this.getLabelList().then(() => {
        this.getPictureList();
      })
    },
    activeLabel() {
      this.getPictureList();
    },
    'Label.records'() {
      // 监听改动获取数据集状态
      this.$emit('getDatasetStatus')
    },
    Pictures(pictures) {
      Object.assign(this.pagination, {
        currentPage: pictures.current,
        size: pictures.size,
        totalCount: pictures.total,
      })
      // 监听改动获取数据集状态
      this.$emit('getDatasetStatus')
    },
    'Pictures.records'(val) {
      this.imglist = []
      if (val) {
        val.forEach(item => {
          this.imglist.push(this.photoBaseUrl + item.fileUrl)
        });
      }
    },
    // 获取目标图片
    targetFileList: {
      handler(val) {
        if (val && val.length) {
          this.PicturesData = val
        } else {
          this.PicturesData = []
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {
    this.localStorageUploadTip();
    this.localStorageUploadTipTarget();
  },
  methods: {
    // 切换文件、目标文件
    onTargetFile(val) {
      this.uploadTipsType = val
      this.Pictures = {
        records: [],
        size: 20,
        current: 1,
        total: 0,
      }
      this.PicturesData = [];

      if (val == 3) {
        this.$emit('getTargetFileByTraining'); // 获取目标文件
      } else {
        this.getPictureList(); // 获取文件集
      }
    },
    // 获取目标文件
    getTargetFile() {
      this.$emit('getTargetFileByTraining');
    },
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    // 预览文件
    onFilePreview(fileUrl) {
      this.fileUrl = this.photoBaseUrl + fileUrl;
      this.dialogvisibleview = true;
    },
    // 标签处理，标签最多 20 个
    getLabelList() {
      let data = {
        datasetId: this.activeDataset
      }

      return new Promise((resolve, reject) => {
        MARKCENTER.getLabelByDatasetId(data).then((result) => {
          if (result.isSuccess) {
            this.Label.records = result.data
            if (result.data.length) {
              this.activeLabel = result.data[0].labelId
            }
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
    // 检测标题命名值
    checkLabelValue(value) {
      var result = false;
      if (!/^[\u4e00-\u9fa5\_A-Za-z0-9]+$/.test(value)) {
        this.$message.error('标签名称只能由汉字、字母、数字组成');
        result = true;
      }

      return result;
    },
    /**
     * 创建标签 分类标签  @data  "datasetId"数据集id labelName标签名称
     */
    addLabel() {
      let datasetId = this.activeDataset,
        labelName = this.popupData.labelName,
        data = {
          datasetId: datasetId,
          labelName: labelName,
        };

      // 标签命名检测，只能由汉字、字母、数字组成
      if (this.checkLabelValue(labelName)) {
        return
      };

      MARKCENTER.addDatasetLabel(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg);
          this.cancelPopup(); // 关闭弹窗
          if (!this.Label.records) {
            this.Label.records = [];
          }

          this.getLabelList(); // 获取标签列表
          this.popupData.labelName = '';
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    // 删除标签
    activeLabelDeletePopup(labelId, datasetId, index) {
      this.popupActive = 'label_delete'
      this.popupData.labelDelete = {
        labelId: labelId,
        datasetId: datasetId,
        index: index,
      }
    },
    // 确认删除标签
    deleteLabel(labelId, datasetId, index) {
      var label = this.Label.records[index],
        labelName = label.labelName,
        data = {
          labelName: labelName,
          labelId: labelId,
          datasetId: datasetId,
          editorType: this.modelType,
        };

      // 如果已激活的标签，需要删除激活
      if (labelId === this.activeLabel) {
        this.activeLabel = ''
      }
      MARKCENTER.deleteDatasetLabel(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success('已删除标签：' + labelName);
          this.$emit('getDatasetStatus'); // 获取状态
          this.Label.records.splice(index, 1);
          this.Label.total -= 1;
          this.getLabelList(); // 获取标签列表
          // 初始化处理
          if (this.Label.records && this.Label.records.length > 0) {
            this.activeLabel = this.Label.records[0].labelId;
          } else {
            this.Pictures.records = null;
            this.Pictures.total = 0;
          }
        } else {
          this.$message.error(result.returnMsg);
        }
      })
    },
    // 数据集文件处理  根据标签id查询文件列表
    // tips:文件分类中，需要数据集和分类标签完备情况下使用
    getPictureList(current) {
      var pageIndex_ = current ? current : 1,
        pageSize = this.Pictures.size,
        data = {};

      // 分类里面数据和标签分类同时存在才能获取
      if (!this.activeDataset || !this.activeLabel) {
        return
      };

      data = {
        editorType: this.modelType, // 类型
        datasetId: this.activeDataset, // 数据集id
        labelId: this.activeLabel, // 标签id
        pageNum: pageIndex_, // 当前页数
        pageSize: pageSize, // 每页条数
        isTag: 0, // 是否标注 1:已标注;0:未标注（图像分类图片不需要设置标注，全部为0）
      };

        // 请求图片列表
      MARKCENTER.getFileByLabelId(data).then((result) => {
        if (result.isSuccess) {
          this.Pictures = result.data;
          // 当前页没有文件回调获取上一页文件
          this.blackGetPictureList();
        } else {
          this.Pictures = {
            records: [],
            size: 20,
            current: 1,
            total: 0,
          };
        }
      })
    },
    // 当前页没有文件回调获取上一页文件
    blackGetPictureList() {
      if (this.Pictures && this.Pictures.current > 1 && this.Pictures.records.length === 0) {
        let currentPageNum = this.Pictures.current - 1;
        this.getPictureList(currentPageNum);
      }
    },

    // 激活标签选中
    activeCatetoryLabel(labelId /*, index*/) {
      this.activeLabel = labelId;
    },
    // 弹窗处理
    // 取消
    cancelPopup() {
      this.popupActive = '';
      // TODO: popupData 考虑是否要清除
    },
    // 删除
    activeDeletePopup(fileId, index) {
      this.popupActive = 'delete';
      // TODO: popupData 数据添加
      this.popupData.delete.index = index;
    },
    // 删除操作弹窗
    deleteOperate() {
      if (this.popupActive === 'delete') { // 删除文件
        this.deletePicture();
      } else if (this.popupActive === 'label_delete') { // 删除标签
        let labelDelete = this.popupData.labelDelete,
          labelId = labelDelete.labelId,
          datasetId = labelDelete.datasetId,
          index = labelDelete.index;

        this.deleteLabel(labelId, datasetId, index);
      }

      // 关闭弹窗
      this.cancelPopup();
    },
    // 确认删除文件
    deletePicture() {
      var deleteIndex = this.popupData.delete.index,
        file = this.Pictures.records[deleteIndex],
        data = {
          fileId: file.fileId,
          fileName: file.fileName,
          editorType: this.modelType,
        };

      MARKCENTER.deleteDatasetFile(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(`已删除${this.modelTypeCompany(this.modelType)}：` + file.fileName);
          this.getPictureList(this.Pictures.current);
          this.$emit('getDatasetStatus'); // 获取状态
        } else {
          this.$message.error(result.returnMsg);
        }
      })
    },
    // 标签重命名
    activeRenameLabelPopup(labelName, labelId, index) {
      this.popupActive = "rename";
      this.popupData.rename.index = index;
      this.popupData.rename.value = labelName;
      this.popupData.rename.flag = "label";
    },
    // TODO:确认标签重命名
    renameLabel() {
      // if (!this.popupData.rename.value) {
      //   return this.$message.error('重命名不能为空！')
      // }
      // 标签命名检测，只能由汉字、字母、数字组成
      if (this.checkLabelValue(this.popupData.rename.value)) {
        return
      }
      var index = this.popupData.rename.index,
        labelName = this.popupData.rename.value,
        label = this.Label.records[index],
        labelId = label.labelId,
        datasetId = label.datasetId,
        data = {};

      data = {
        labelName: labelName,
        labelId: labelId,
        datasetId: datasetId
      };

      MARKCENTER.updateDatasetLabel(data).then(result => {
        if (result.isSuccess) {
          let iLabel = this.Label;
          iLabel.records[index].labelName = labelName;
          this.Label = iLabel;
          this.cancelPopup();
          this.$message.success(result.returnMsg);
        }else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    // 文件重命名
    activeRenamePopup(obj, index) {
      this.popupActive = 'rename';
      this.popupData.rename.index = index;
      this.popupData.rename.fileId = obj.fileId;
      this.popupData.rename.value = obj.fileName;
      this.popupData.rename.flag = "picture";
    },
    // 确认重命名
    renameOperate() {
      // 在弹窗数据中，存放 flag
      if (this.popupData.rename.flag === "label") {
        this.renameLabel(); // 确认标签重命名
      } else if (this.popupData.rename.flag === "picture") {
        this.renamePicture(); // 确认文件重命名
      }
    },
    // TODO:确认文件重命名
    renamePicture() {
      if (!this.popupData.rename.value) {
        return this.$message.error('重命名不能为空！');
      }
      if (this.popupData.rename.value.length > 20) {
        return this.$message.error('重命名不能超过20个字符！');
      }
      let renameIndex = this.popupData.rename.index,
        fileName = this.popupData.rename.value,
        fileId = this.popupData.rename.fileId,
        data = {
          fileId: fileId,
          fileName: fileName,
          editorType: this.modelType,
        },
        list = [];

      MARKCENTER.updateDatasetFile(data).then((result) => {
        if (result.returnCode === 200) {
          list = JSON.parse(JSON.stringify(this.Pictures.records));
          list[renameIndex].fileName = fileName;
          this.Pictures.records = list;
          this.cancelPopup(); // 关闭弹窗
          this.$message.success(result.returnMsg);
        } else {
          this.$message.error(result.returnMsg);
        }
      })
    },

    // 引用数据集
    quoteDataset() {
      this.drawerShow = true // 打开数据集弹窗
    },
    // 文件上传
    uploadPictures() {
      if (this.PicturesData.length >= 10 && this.uploadTipsType == 3) {
        return this.$message.error(`目标校验的${this.modelTypeCompany(this.modelType)}总数不超过10个哦~`);
      }
      if (this.Pictures.total >= 200 && this.uploadTipsType == 1) {
        return this.$message.error(`单个分类标签的${this.modelTypeCompany(this.modelType)}总数不超过200个哦~`);
      }
      let uploadNoTip = this.uploadTipsType == 1 ? this.popupData.uploadNoTip : this.popupData.uploadNoTipTarget
      // TODO: 数据集选定、分类标签选定
      if (!uploadNoTip) {
        this.activeUploadTipPopup();
      } else {
        // 直接上传
        this.uploadPicturesToDataset();
      }
    },
    // 上传图片到相应标签的数据集中
    uploadPicturesToDataset() {
      var uploadFileNode = document.createElement('input'), // 创建上传按钮
        fileList = [], // 文件列表
        self = this,
        modelType = self.modelType;

      uploadFileNode.setAttribute('type', 'file'); // 设置上传按钮属性
      uploadFileNode.setAttribute('multiple', 'ture'); // 多文件上传
      
      if (modelType == 1 || modelType == 2) {
        uploadFileNode.setAttribute("accept", "image/jpeg, image/jpg"); // 限制图片除外的文件上传
      }
      if (modelType == 3 || modelType == 4) {
        uploadFileNode.setAttribute('accept', '.txt'); // 限制txt除外的文件上传
      }
      if (modelType == 5 || modelType == 6) {
        uploadFileNode.setAttribute('accept', '.mp3, .wav'); // 限制.mp3|.wav音频除外的文件上传
      }

      uploadFileNode.click(); // 触发上传事件

      // 上传进程
      uploadFileNode.onchange = function uploadChange(evt) {
        var formdata = new FormData(),
          fileNum = self.uploadTipsType == 3 ? 10 : 200,
          list;

        // 文件装配
        fileList = evt.target.files;
        // 如果存在不是 image/jpeg 格式的图片就会触发停止上传的操作
        // jpg/jpeg 是一样，同属于 image/jpeg 格式
        list = Array.from(fileList);

        if (list.length > fileNum) {
          return self.$message.error(`上传失败，单次上传${self.modelTypeCompany(modelType)}限制${fileNum}个!`);
        }

        if (self.uploadTipsType == 3 && (self.PicturesData.length + list.length > 10)) {
          return self.$message.error(`上传失败，目标校验的${self.modelTypeCompany(modelType)}总数不超过10个哦~`);
        }
        if (self.uploadTipsType != 3 && (self.Pictures.total + list.length > 200)) {
          return self.$message.error(`上传失败，单个分类标签的${self.modelTypeCompany(modelType)}总数不超过200个哦~`);
        }

        self.fullscreenLoading = self.$loading({
          lock: true,
          text: `${self.modelTypeCompany(modelType)}上传中请稍等...`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 图片
        if (modelType == 1 || modelType == 2) {
          self.noFile = 0;
          list.forEach((item, index) => {
            // self.selectUploadPicSize(item, list, index);
            let typeFlag = self.$util.filesFormatCheck(item, "jpg|jpeg"); // 检验文件类型
            if (typeFlag) {
              self.noFile++
              self.$message.error(`${item.name}上传失败，只允许上传 jpg/jpeg 格式图片！`);
            } else {
              formdata.append('file', item);
            }
          });
  
          if (list.length === self.noFile) {
            return self.fullscreenLoading.close(); // 关闭Loading
          }
          self.UploadMultipleFileApi(formdata) // 上传图片接口调用
        }
        // 文本/音频
        if (modelType == 3 || modelType == 4 || modelType == 5 || modelType == 6) {
          let noFile = 0;
          list.forEach(async (file) => {
            if (modelType == 3 || modelType == 4) {
              let typeFlag = self.$util.filesFormatCheck(file, 'txt');
              if (typeFlag) {
                noFile++;
                self.$message.error(`${file.name}上传失败，请上传格式为txt的文件!`);
              } else if (file.size > 500 * 1024) {
                noFile++;
                self.$message.error(`上传失败，文件名称为${file.name}格式过大!`);
              } else {
                formdata.append('file', file);
              }
            }
            if (modelType == 5 || modelType == 6) {
              let typeFlag = self.$util.filesFormatCheck(file, 'mp3|MP3|wav|WAV');
              if (typeFlag) {
                noFile++;
                self.$message.error(`${file.name}上传失败，请上传格式为 wav/mp3 的音频!`);
              } else if (file.size > 5242880) {
                noFile++;
                self.$message.error(`上传失败，音频名称为${file.name}格式过大!`);
              } else {
                formdata.append('file', file);
              }
            }
          })
          if (list.length === noFile) {
            return self.fullscreenLoading.close(); // 关闭Loading
          }
          self.UploadMultipleFileApi(formdata) // 批量上传接口
        }
      }

      uploadFileNode.onprogress = function uploadProgress(evt) {
        console.log(evt);
      }
    },
    // async selectUploadPicSize(ev, arrList, index) {
    //   var self = this;
    //   var uploadFile = ev;

    //   if (uploadFile) {
    //     if (window.FileReader) {
    //       var fr = new FileReader()
    //        fr.onloadend = await async function(e) {
    //         let typeFlag = self.$util.filesFormatCheck(uploadFile, "jpg|jpeg"); // 检验文件类型
    //         if (typeFlag) {
    //           self.noFile++
    //           self.$message.error(`${uploadFile.name}上传失败，只允许上传 jpg/jpeg 格式图片！`);
    //         } else {
    //           // 声明新Image
    //           var img = new Image()
    //           // 此处不做任何压缩直接读取文件流显示为图片（可扩展为压缩图片后显示）
    //           img.src = e.target.result
    //           img.onload = await function() {
    //             // 图片格式大小尺寸区间
    //             if (uploadFile.size > 4194304) {
    //               self.noFile++
    //               self.$message.error(`上传失败，图片名称为${uploadFile.name}格式过大！`);
    //             } else if (this.width > 2048 || this.height > 2048 ) {
    //               self.noFile++;
    //               self.$message.error(`上传失败，图片名称为“${uploadFile.name}”分辨率大于2048px*2048px！`);
    //             } else if (this.width < 64 || this.height < 64) {
    //               self.noFile++;
    //               self.$message.error( `上传失败，图片名称为“${uploadFile.name}”分辨率小于64px*64px！`);
    //             } else {
    //               self.formdata.append('file', uploadFile);
    //             }
    //           }
    //         }

    //         if (arrList.length === (index + 1)) {
    //           setTimeout(() => {
    //             if (arrList.length === self.noFile) {
    //               return self.fullscreenLoading.close(); // 关闭Loading
    //             }
    //             self.UploadMultipleFileApi(self.formdata) // 上传图片接口调用
    //           }, 1000);
    //         }
    //       }
    //       fr.readAsDataURL(uploadFile)
    //     }
    //   }
    // },
    // 上传图片接口调用
    UploadMultipleFileApi(formdata) {
      COMMON.UploadMultipleFile(formdata).then((result) => {
        // console.log('上传接口返回', result.data)
        if (result.returnCode == 200) {
          let dataList = JSON.parse(JSON.stringify(result.data));
          let imgList = [];
          let data = {
            editorType: this.modelType,
            datasetId: this.activeDataset,
            labelId: this.activeLabel,
            list: []
          };
          
          if (this.modelType == 1) {
            dataList.forEach((item, index) => {
              // 图片格式大小尺寸区间
              if (item.size && item.size > 4194304) {
                setTimeout(() => {
                  this.$message.error(`上传失败，图片名称为${item.fileName}格式过大！`);
                }, index*5);
              } else if (item.width&&item.width > 2048 || item.height&&item.height > 2048 ) {
                setTimeout(() => {
                  this.$message.error(`上传失败，图片名称为“${item.fileName}”分辨率大于  2048px*2048px！`);
                }, index*5);
              } else if (item.width&&item.width < 64 || item.height&&item.height < 64) {
                setTimeout(() => {
                  this.$message.error( `上传失败，图片名称为“${item.fileName}”分辨率小于  64px*64px！`);
                }, index*5);
              } else {
                imgList.push(item);
              }
            });
  
            if (imgList.length === 0) {
              this.fullscreenLoading.close(); // 关闭Loading
              this.formdata = new FormData();  // 释放
              return
            }
            // 校验图片jpg|jpeg
            this.verifyImgs(imgList).then(res => {
              if (res.correct && res.correct.length) {
                res.correct.forEach(i => {
                  imgList.forEach(j => {
                    if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
                      data.list.push( {
                        fileName: j.fileName,
                        fileUrl: j.url
                      });
                    }
                  });
                });
                this.uploadImg(data); // 上传到服务器的文件转存到数据库中
              }
            })
          } else {
            let datasetImgList = dataList.map((item) => {
              return {
                fileName: item.fileName, // 文件名称
                fileUrl: item.url, // 文件url
              }
            })
            data.list = datasetImgList;
            this.uploadImg(data)
          }
        } else {
          this.$message.error(result.returnMsg);
          this.fullscreenLoading.close(); // 关闭Loading
        }
        this.formdata = new FormData(); // 释放
      }).catch((error)=>{
        this.formdata = new FormData(); // 释放
        this.fullscreenLoading.close(); // 关闭Loading
        this.$message.error('上传失败!');
      })
    },
    // 存文件
    uploadImg(data) {
      if (this.uploadTipsType == 3) {
        data.trainingId = this.trainingId
        // 上传到服务器的目标文件转存到数据库中
        MARKCENTER.addTrainingTargetFile(data).then((result) => {
          if (result.isSuccess) {
            this.$message.success(result.returnMsg);
            this.fullscreenLoading.close(); // 关闭Loading
            // TODO:刷新目标图片数据
            this.$emit('getTargetFileByTraining');
          } else {
            this.$message.error(result.returnMsg);
            this.fullscreenLoading.close(); // 关闭Loading
          }
        }).catch((error)=>{
          this.fullscreenLoading.close(); // 关闭Loading
        })
      } else {
        // 上传到服务器的文件转存到数据库中
        MARKCENTER.addDatasetFile(data).then((result) => {
          if (result.isSuccess) {
            this.$message.success(result.returnMsg);
            this.fullscreenLoading.close(); // 关闭Loading
            // TODO:刷新图片数据
            this.getPictureList()
          } else {
            this.$message.error(result.returnMsg);
            this.fullscreenLoading.close(); // 关闭Loading
          }
        }).catch((error)=>{
          this.fullscreenLoading.close(); // 关闭Loading
        })
      }
    },

    // 图片上传说明
    activeUploadTipPopup() {
      this.popupActive = 'uploadtip';
    },
    // 上传提示显示后再进行上传操作
    confirmUploadTip() {
      this.cancelPopup(); // 关闭弹窗
      // TODO:上传图片事件触发
      this.uploadPicturesToDataset();
    },
    // 上传文件
    uploadNoTipChange(val) {
      if (this.uploadTipsType == 3) {
        this.localStorageUploadTipTarget('save', val);
      } else {
        this.localStorageUploadTip('save', val);
      }
    },
    // 文件上传说明是否显示存储
    localStorageUploadTip(type, value) {
      if (type === 'save') {
        this.popupData.uploadNoTip = value;
        window.localStorage.setItem(`__upload_training_classification${this.modelType}_tip__`, value);
      } else {
        let uploadNoTip = window.localStorage.getItem(`__upload_training_classification${this.modelType}_tip__`);
        this.popupData.uploadNoTip = uploadNoTip ? uploadNoTip : false;
      }
    },
    // 目标文件上传说明是否显示存储
    localStorageUploadTipTarget(type, value) {
      if (type === 'save') {
        this.popupData.uploadNoTipTarget = value;
        window.localStorage.setItem(`__upload_target_classification${this.modelType}_tip__`, value);
      } else {
        let uploadNoTipTarget = window.localStorage.getItem(`__upload_target_classification${this.modelType}_tip__`);
        this.popupData.uploadNoTipTarget = uploadNoTipTarget ? uploadNoTipTarget : false;
      }
    },
    // 图片翻页
    handleCurrentChange(current) {
      this.getPictureList(current);
    },
    // 添加标签--最多能创建 15 个标签分类
    activeAddTagPopup() {
      this.popupData.labelName = '';
      if (!this.activeDataset) {
        return this.$message.warning('请选择数据集再进行标签操作');
      }
      this.popupActive = 'add_tag';
    },
  },
}
</script>

<style lang="scss" scoped>
@import './Training_common.scss';
@import './TrainingStepClassification.scss';
</style>
